import { actions, constants } from '../constants'
import { map } from 'lodash'
const { CONTACT } = actions

const initialState = {
    contacts: [],
    loading: false,
    detail: null,
    filters: {},
    pagination: {},
    error: null,
    messages: null,
}

/**
 * @param state
 * @param action <Promise>
 */
export default function reducer(state = initialState, action) {

    switch (action.type) {
        case CONTACT.RESET: {
            return {
                ...state, 
                contacts: [],
                loading: false,
                detail: null,
                filters: {},
                pagination: {},
                error: null,
                messages: null,
            }
        }
        case CONTACT.START: {
            return {...state, loading: true}
        }
        case CONTACT.CLEAR_MESSAGES: {
            return {...state, messages: null, errors: null}
        }
        case CONTACT.ERROR: {
            let error = action.payload.response || {}

            error = error.data ? error.data.message : "error.errorOccurred"
            
            return {
                ...state, 
                loading: false, 
                errors: error, 
                messages: null, 
                detail: {
                    ...state.detail, 
                    loading: false
                }
            }
        }
        case CONTACT.SUCCESS: {
            return {
                ...state, 
                loading: false, 
                errors: null, 
                messages: action.payload,
                detail: {
                    ...state.detail, 
                    loading: false
                }
            }
        }
        case CONTACT.SAVE: {
            
            return {
                ...state, 
                loading: false, 
                contacts: action.payload.data,
                contactsTransformed: map(action.payload.data, c => {
                    return {
                        ...c,
                        title: c.title ?? "(no title)",
                        person: `${c.prefix ?? ''} ${c.first_name ?? ''} ${c.middle_name?.substr(0,1) ?? ""} ${c.last_name || ""}`,
                        email: c.home_emails.concat(c.work_emails).join(", "),
                        description: c.description,
                        contact_number: c.home_telephones.concat(c.work_telephones).join(", "),
                        actions: [
                            constants.MENU_ACTION_DELETE,
                        ]
                    }
                }), 
                pagination: action.payload.pagination
            }
        }
        case CONTACT.SAVE_CONTACT_DETAILS: {
            
            const detail = action.payload

            return {
                ...state, 
                loading: false,
                detail: {
                    ...state.detail,
                    ...detail,
                },
            }
        }
        case CONTACT.SAVE_FILTERS: {
            return {
                ...state, 
                loading: false, 
                filters: {},
            }
        }
        case CONTACT.CLEAR_CONTACT_DETAILS: {
            return {
                ...state, 
                loading: false,
                detail: null, 
            }
        }
        default: {}
    }

    return state
}